import React, { createContext, ReactNode, useContext, useState } from 'react';

import { ScoreWindow, TTimeRange } from 'src/types';

interface ContextType {
  dashboardEnv: string;
  setDashboardEnv: any; // (env: string) => void;
  timeRange: TTimeRange;
  setTimeRange: any;
  scoreWindow: ScoreWindow;
  setScoreWindow: (window: ScoreWindow) => void;
}

const EnvironmentContext = createContext<ContextType>({
  dashboardEnv: 'GARM',
  setDashboardEnv: () => {},
  timeRange: {
    from: new Date(),
    to: new Date(),
  },
  setTimeRange: () => {},
  scoreWindow: 'last12months',
  setScoreWindow: () => {},
});

interface Props {
  children: ReactNode;
}

export const EnvironmentProvider: React.FC<Props> = ({ children }) => {
  const [dashboardEnv, setDashboardEnv] = useState<string>('GARM');
  const [timeRange, setTimeRange] = useState<TTimeRange>({
    from: new Date('2019/1/1'),
    to: new Date(),
  });
  const [scoreWindow, setScoreWindow] = useState<ScoreWindow>('last12months');

  return (
    <EnvironmentContext.Provider
      value={{
        dashboardEnv,
        setDashboardEnv,
        timeRange,
        setTimeRange,
        scoreWindow,
        setScoreWindow,
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};

export const useEnvironment = () => useContext(EnvironmentContext);
export default useEnvironment;
